import React, {Suspense} from 'react';
import {Redirect, Switch} from "react-router-dom";
import {ContentRoute, LayoutSplashScreen} from "../../../../_metronic/layout";
import {CardPage} from "./card/CardPage";
import {NewOrderPage} from "./orders/NewOrderPage";
import {OrdersListPage} from "./orders-list/OrdersListPage";

export default function SalePage(){
    return(
        
        <Suspense fallback={<LayoutSplashScreen/>}>
            <Switch>

                {
                    <Redirect
                        exact={true}
                        from={"/sales"}
                        to={"/sales/orders"}
                        />
                }
                <ContentRoute path={"/sales/orders/new"} component={NewOrderPage}/>
                <ContentRoute path={"/sales/orders/cart"} component={CardPage}/>
                <ContentRoute path={"/sales/orders/list"} component={OrdersListPage}/>
            </Switch>
        </Suspense>
    )
}